<div class="calculation-cache-verification">
    <div class="dialog__close" (click)="close()" cdkFocusRegionstart>
        <span class="material-icons">close</span>
    </div>

    <h2 class="calculation-cache-verification__header">
        <div class="calculation-cache-verification__header__title">
            {{ (CALCULATION_CACHE_VERIFICATION_DIALOG + '.header1') | translate }}
        </div>
        <div class="calculation-cache-verification__header__subtitle">
            {{ (CALCULATION_CACHE_VERIFICATION_DIALOG + '.header2') | translate }}
        </div>
    </h2>

    <div class="calculation-cache-verification__postal-code-field">
        <app-text-field [bean]="bean"
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[POSTAL_CODE_CONTROL_KEY]"
                        [fieldConfig]="formFactoryService.fieldConfig(POSTAL_CODE_CONTROL_KEY, formConfig)"
                        [context]="CALCULATION_CACHE_VERIFICATION_DIALOG"
        >
        </app-text-field>
    </div>

    <div *ngIf="verificationValid"
         class="calculation-cache-verification__verification-message"> {{ (CALCULATION_CACHE_VERIFICATION_DIALOG + '.verificationMessage') | translate}}
    </div>

    <div *ngIf="!verificationValid" class="calculation-cache-verification__verification-invalid">
        <span *ngIf="verificationAttempt < MAX_VERIFICATION_ATTEMPT"> {{ (CALCULATION_CACHE_VERIFICATION_DIALOG + '.verificationInvalid') | translate}} </span>
        <span *ngIf="verificationAttempt === MAX_VERIFICATION_ATTEMPT"> {{ (CALCULATION_CACHE_VERIFICATION_DIALOG + '.verificationInvalidLastAttempt') | translate}} </span>
    </div>

    <div class="calculation-cache-verification__button">
        <button (click)="submitForm()" class="button btn btn--blue btn--small-padding">
            {{ (CALCULATION_CACHE_VERIFICATION_DIALOG + '.submitButton') | translate}}
        </button>
    </div>
</div>
